// ----------------------------------------------------------------------
/* eslint-disable */
import { useContext, useState } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import { alpha, useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import Alert from '@mui/material/Alert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import { useRouter } from 'src/routes/hooks';

import { bgGradient } from '../theme/css';

import Logo from '../components/logo';
// import Iconify from 'src/components/iconify';
import { AuthContext } from '../context/AuthContext';
import { AppBar } from '@mui/material';

export default function LoginPage() {

  const theme = useTheme();

  const [showPassword, setShowPassword] = useState(false);

  const { loginUser, loginInfo, loginError, isLoginLoading, updateLoginInfo } = useContext(AuthContext);



  // const handleClick = () => {
  //   router.push('/dashboard');
  // };

  const renderForm = (
    <> 
      <form action="" onSubmit={loginUser}>

        <Stack spacing={3}>
          {loginError&&<Alert severity="error">{loginError}</Alert>}
          <TextField name="email" label="Email address" onChange={((e) => updateLoginInfo({ ...loginInfo, email: e.target.value }))} />
          <TextField
            name="password"
            label="Password"
            onChange={((e) => updateLoginInfo({ ...loginInfo, password: e.target.value }))}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  {showPassword ?<VisibilityIcon/> :<VisibilityOffIcon/>}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
          {/* <Link variant="subtitle2" href="/admin/forgot-password" underline="hover">
            Forgot password?
          </Link> */}
        </Stack>

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          color="inherit"
          loading={isLoginLoading}
        >
          Login
        </LoadingButton>
          
      </form>
    </>
  );

  return (
    
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.background.default, 0.9),
          imgUrl: '/assets/background/overlay_4.jpg',
        }),
        height: 1,
      }}
    >
      <Logo
        sx={{
          position: 'fixed',
          top: { xs: 16, md: 24 },
          left: { xs: 16, md: 24 },
        }}
      />

      <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}  p={2}>
        <Card
          sx={{
            p: 5,
            width: 1,
            maxWidth: 420,
          }}
        > 
          <Typography variant="h4" sx={{mb:4}}>Sign in to Admin</Typography>

          {/* <Typography variant="body2" sx={{ mt: 2, mb: 5 }}>
            Don’t have an account?
            <Link  href="/admin/register" variant="subtitle2" sx={{ ml: 0.5 }}>
              Get started
            </Link>
          </Typography> */}
          {renderForm}
        </Card>
      </Stack>
    </Box>

  );
}
 